import React from 'react';
import Image from 'next/image';
import { cx } from '@/utils';

import GovCo2025 from '../../Icons/GovCo2025';
import styles from './styles.module.css';

const FooterGovCo = () => {
  return (
    <section className={'bg-marine'}>
      <div className={cx(styles.govco, 'inner')}>
        <Image src={'/govco_co.png'} alt={'Gov.co'} width={48} height={48} />
        <div className={'h-[48px] w-[1px] bg-white'} />
        {/* <Image src={'/logo_GOV_CO.png'} alt={'Gov.co logo'} width={130} height={34} /> */}
        <GovCo2025 width={130} height={34} variant="white" />
      </div>
    </section>
  );
};

export default FooterGovCo;
